module.exports = __webpack_public_path__ + "img/procurement_refund.577ce6c1.png";